<template>
    <div class="row no-wrap items-center">
        <q-checkbox
            class="q-mr-sm"
            color="primary"
            :style="disable ? `display:none` : null"
            dense
            @input="onSelect"
            v-model="select"
        />

        <div class="flex justify-center" style="position: relative">
            <q-img
                style="width: 80px; height: 80px"
                basic
                :placeholder-src="require('@/assets/image-not-found.png')"
                contain
                ratio="1"
                :src="imageSrc"
                @error="retryImageSrc(info.product.cprcode)"
            ></q-img>

            <q-img
                basic
                v-if="badge.left"
                :src="`${badge.left}`"
                class="overlay"
            />

            <q-img
                basic
                v-if="badge.right"
                :src="`${badge.right}`"
                class="overlay-right"
            />
        </div>

        <div class="col row q-pl-sm">
            <div class="col content q-mb-sm">
                <div class="title text-primary">
                    {{ info.product.hemaNameEn }}
                </div>

                <div class="subtitle text-grey-10">
                    {{ info.product.hemaBrandEn }}
                </div>

                <q-badge outline v-if="preorder.preType" color="lime-10"
                    >Pre Order</q-badge
                >
            </div>

            <div class="col-3 text-right">
                <div class="lastPrice text-grey" v-if="lastPrice">
                    {{ lastPrice | formattedPrice }}
                </div>
                <div class="price text-primary">
                    {{ price | formattedPrice }}
                </div>
                <div class="text-grey-10">/{{ info.product.hemaSizedesc }}</div>
            </div>

            <div class="col-12 row">
                <q-input
                    type="number"
                    dense
                    v-model.number="quantity"
                    outlined
                    :disable="disable"
                    class="text-center"
                    style="max-width: 140px"
                    :debounce="200"
                >
                    <template v-slot:before>
                        <q-btn
                            :disable="disableButton"
                            round
                            dense
                            flat
                            style="color: #2c2a74"
                            icon="fas fa-minus-square"
                            @click="subtract"
                        >
                        </q-btn>
                    </template>

                    <template v-slot:after>
                        <q-btn
                            :disable="disableButton"
                            round
                            dense
                            flat
                            style="color: #2c2a74"
                            icon="fas fa-plus-square"
                            @click="add"
                        >
                        </q-btn>
                    </template>
                </q-input>
            </div>
            <!-- <div class="col" /> -->
            <!-- <div class="row"> -->
            <!-- <q-icon
          size="17px"
          name="favorite"
          style="padding: 10px; cursor: pointer"
          @click="onFavorite"
          :color="isFavorite ? `red` : `grey`"
        ></q-icon> -->
            <!-- <q-icon
                    @click="onRemove"
                    size="17px"
                    name="far fa-trash-alt"
                    style="color: #aaa; padding: 10px; cursor: pointer"
                ></q-icon> -->
            <!-- </div> -->
            <!-- </div> -->
        </div>

        <!-- <div> -->
        <q-icon
            @click="onRemove"
            size="17px"
            name="far fa-trash-alt"
            style="color: #aaa; padding: 10px; cursor: pointer"
        />
        <!-- </div> -->

        <q-dialog v-model="dialog" persistent>
            <DialogAlert
                :message="message"
                left-btn="Cancel"
                right-btn="Confirm"
                @leftClick="onleftClickDialog"
                @rightClick="onrightClickDialog(info.cprcode)"
            />
        </q-dialog>
    </div>
</template>

<script>
import { QCheckbox, QInput, QIcon, QDialog, QBadge } from "quasar";
import priceFormat from "@/utils/priceFormat";
import imageSrc from "@/mixins/imageSrc";
// import preorder from "@/mixins/preorder";
import DialogAlert from "@/ui/components/DialogAlert";
const components = {
    QCheckbox,
    QInput,
    QIcon,
    QDialog,
    QBadge,
};
export default {
    name: "CartItem",
    props: ["disable", "info"],
    components: {
        ...components,
        DialogAlert,
    },
    mixins: [imageSrc],
    data() {
        return {
            select: true,
            loading: false,
            disableButton: false,
            dialog: false,
            dialogFrom: null,
            message: null,
            quantity: 0,
            isFavorite: false,
        };
    },
    computed: {
        branchCode() {
            return parseInt(this.$store.state["branch"]["branch"].code);
        },
        badge() {
            return {
                left: this.info?.product?.badgeLeft,
                right: this.info?.product?.badgeRight,
            };
        },
        price() {
        if (this.info.product.availableStore.get(this.branchCode || 1000)) {
            const store = this.info.product.availableStore.get(
                this.branchCode || 1000
            );
            if (store.price) {
                return store.price.price;
            }
        }
        return 0;
        },
        lastPrice() {
            if (this.info.product.availableStore.get(this.branchCode || 1000)) {
                const store = this.info.product.availableStore.get(
                    this.branchCode || 1000
                );
                if (store.price) {
                    if (store.price.price !== store.price.lastPrice) {
                        return store.price.lastPrice;
                    }
                }
            }
            return 0;
        },
        preorder() {
            return this.info.product.preOrder || {};
        },
    },
    watch: {
        "info.product.cprcode": {
            handler: function (value) {
                this.initializeImageSrc(value);
            },
        },
        "info.selected": {
            immediate: true,
            handler: function (newValue) {
                this.select = newValue;
            },
        },
        "info.basketItem.quantity": {
            immediate: true,
            handler: function (newValue) {
                this.quantity = newValue;
            },
        },
        quantity: {
            handler: function (newValue, oldValue) {
                this.onUpdate(newValue, oldValue);
            },
        },
    },
    created() {
        console.log("CartItem created");
    },
    mounted() {
        this.initializeImageSrc(this.info.product.cprcode);
    },
    methods: {
        onSelect(selected) {
            console.log("onSelect", selected);
            const payload = this.info;
            payload.selected = selected;
            console.log("commit onSelect with payload:", payload);
            this.$store.commit("cartData/setSelect", payload);
            this.$store.dispatch("cartData/getCost");
        },
        async onUpdate(newValue, oldValue) {
            console.log("onUpdate");
        },
        async add() {
            await this.$store.dispatch(
                "cart/incrementProduct",
                this.info.product
            );
        },
        async subtract() {
            if (this.info.basketItem.quantity <= 1) {
                this.onRemove();
            } else {
                await this.$store.dispatch(
                    "cart/decrementProduct",
                    this.info.product
                );
            }
        },
        onRemove() {
            this.dialog = true;
            this.message = "Do you want to remove this item ?";
            this.dialogFrom = "onRemove";
        },
        async onDeleteItem() {
            await this.$store.dispatch("cart/removeProduct", this.info.product);
        },
        onleftClickDialog() {
            this.dialog = false;
        },
        onrightClickDialog() {
            this.dialog = false;
            this.onDeleteItem();
        },
    },
};
</script>

<style scoped>
>>> .q-field__native,
.q-field__input {
    text-align: center;
}
.content {
    overflow: hidden;
}
.lastPrice {
    font-size: 14px;
    text-decoration: line-through;
}
.price {
    font-size: 18px;
    font-weight: bold;
}
.title {
    font-size: 16px;
    font-weight: 600;
}
.subtitle {
}
.overlay {
    position: absolute;
    width: 26px;
    height: 26px;
    top: 4px;
    left: 4px;
}
.overlay-right {
    position: absolute;
    width: 26px;
    height: 26px;
    top: 4px;
    left: 4px;
}
</style>
